import { PageConfig } from '../../../models/pages'
import { redirectToCheckout } from './redirect-to-checkout'
import { redirect } from './redirect'
import { setMetadata } from './setMetadata'
import { getMetadata } from './getMetadata'
import { setMetadataItem } from './setMetadataItem'
import { getMetadataItem } from './getMetadataItem'
import { clearMetadata } from './clearMetadata'
import { setCustomQuestionAnswer } from './setCustomQuestionAnswer'
import { getCustomQuestionAnswer } from './getCustomQuestionAnswer'
import { clearCustomQuestionAnswer } from './clearCustomQuestionAnswer'
import { getCustomQuestionAnswers } from './getCustomQuestionAnswers'
import { clearCustomQuestionAnswers } from './clearCustomQuestionAnswers'
import { getProgramDesignations } from './getProgramDesignations'

export interface ServiceHandlerArgs {
  iframeId: string
  messageId: number
  payload: unknown
  sendSuccessResponse: (iframeId: string, messageId: number, payload: unknown) => void
  sendErrorResponse: (iframeId: string, messageId: number, error: string) => void
  pageConfig: PageConfig
}

/**
 * Service handler function signature
 * All service handlers must implement this interface
 */
export type ServiceHandler = (args: ServiceHandlerArgs) => Promise<void> | void

/**
 * Service registry mapping service types to their handlers
 */
type ServiceRegistry = Record<string, ServiceHandler>

export const SERVICE_HANDLERS: ServiceRegistry = {
  REDIRECT_TO_CHECKOUT: redirectToCheckout,
  REDIRECT: redirect,
  SET_METADATA: setMetadata,
  SET_METADATA_ITEM: setMetadataItem,
  GET_METADATA: getMetadata,
  GET_METADATA_ITEM: getMetadataItem,
  CLEAR_METADATA: clearMetadata,
  SET_CUSTOM_QUESTION_ANSWER: setCustomQuestionAnswer,
  GET_CUSTOM_QUESTION_ANSWER: getCustomQuestionAnswer,
  CLEAR_CUSTOM_QUESTION_ANSWER: clearCustomQuestionAnswer,
  GET_CUSTOM_QUESTION_ANSWERS: getCustomQuestionAnswers,
  CLEAR_CUSTOM_QUESTION_ANSWERS: clearCustomQuestionAnswers,
  GET_PROGRAM_DESIGNATIONS: getProgramDesignations,
} as const
